/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TicketDto } from '../../models/ticket-dto';
import { UpdateTicketDto } from '../../models/update-ticket-dto';

export interface TicketControllerUpdate$Params {
  id: string;
  centerId: string;
      body: UpdateTicketDto
}

export function ticketControllerUpdate(http: HttpClient, rootUrl: string, params: TicketControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketDto>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketDto>;
    })
  );
}

ticketControllerUpdate.PATH = '/api/ticket/{id}';
